<template>
  <div v-show="visible" class="showPhoto" @click="closeClick">
    <img class="img" :src="url" alt="图片加载失败">
    <div class="watermark">
      <template v-if="showWaterPrint">
        <div class="watermark-row">
          <span class="watermark-item">{{waterPrint.companyName}}</span>
          <span class="watermark-item">{{waterPrint.pcNo}}</span>
          <span class="watermark-item">{{waterPrint.createdTime}}</span>
        </div>
      </template>
      <div v-else-if="pcNo" class="watermark-single">{{pcNo}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      url: {
        type: String,
        default: "",
      },
      pcNo: {
        type: String,
        default: "",
      },
      waterPrint: {
        type: Object,
        default: () => ({}),
      },
      // 是否展示三个字段（公司名称/批次号/创建时间），由外部判断后传入
      showWaterPrint: {
        type: Boolean,
        default: false,
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      closeClick() {
        //子组件可以使用 $emit 触发父组件的自定义事件
        this.$emit("closeClick");
      },
    },
  };
</script>
<style lang="css" scoped>
.showPhoto {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
  height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 99999;
	display: flex;
	align-items: center;
	justify-content: center;
}

.showPhoto .img {
	display: block;
	margin: 5% 0;
	max-width: 100%;
  height: 90%;
	text-align: center;
  position: relative;
}

.showPhoto .watermark {
	position: fixed;
	bottom: 60px;
	left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 10px 20px;
	color: white;
	font-size: 20px;
	line-height: 1.6;
	background: rgba(0, 0, 0, 0.45);
	pointer-events: none;
}

.showPhoto .watermark-row {
	display: flex;
	justify-content: center;
}

.showPhoto .watermark-row-center {
	justify-content: center;
}

.showPhoto .watermark-item {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-right: 20px;
}

.showPhoto .watermark-item:last-child {
	margin-right: 0;
}

.showPhoto .watermark-single {
	text-align: center;
	width: 100%;
}
</style>
